import { findAllOrdersList, findClientOrdersList } from '../../_services/orders_list.service';

export const findAllOrdersListEvent = async () => {
    let res = await findAllOrdersList();
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllClientOrdersListEvent = async (cod_client) => {
    let res = await findClientOrdersList(cod_client);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}